import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { changePageApplication } from 'actions/capital';
import * as clevertapCapital from 'clevertap/capital';
import KoinWorksForm from './KoinworksForm/index';
import TaraliteForm from './TaraliteForm';
import ModalkuForm from './ModalkuForm/index';

class DetailForm extends React.Component {
  render() {
    const {
      sendingRequest,
      businessLocationsState,
      businessStartsState,
    } = this.props;
    const {
      logo,
      loans_type: loansType,
      pre_approved_amount: preApprovedAmount,
      interest_rate: interestRate,
      duration,
      lender_name: lenderName,
      monthly_installment: monthlyInstallment,
      marital_status: isMarried,
      bank_name: bankName,
    } = this.props.capitalForm;
    if (lenderName.toLowerCase() === 'koinworks') {
      return (
        <KoinWorksForm
          loansType={loansType}
          changeField={this.props.changeField}
          businessLocationsState={businessLocationsState}
          businessStartsState={businessStartsState}
          logo={logo}
          preApprovedAmount={preApprovedAmount}
          interestRate={interestRate}
          duration={duration}
          lenderName={lenderName}
          monthlyInstallment={monthlyInstallment}
          isMarried={isMarried}
          bankName={bankName}
          sendingRequest={sendingRequest}
          onClickChange={this._onClickChange}
        />
      );
    }
    if (lenderName === 'Taralite') {
      return (
        <TaraliteForm
          loansType={loansType}
          changeField={this.props.changeField}
          businessLocationsState={businessLocationsState}
          businessStartsState={businessStartsState}
          logo={logo}
          preApprovedAmount={preApprovedAmount}
          interestRate={interestRate}
          duration={duration}
          lenderName={lenderName}
          monthlyInstallment={monthlyInstallment}
          isMarried={isMarried}
          bankName={bankName}
          sendingRequest={sendingRequest}
          onClickChange={this._onClickChange}
        />
      );
    }
    if (lenderName.toLowerCase() === 'modalku') {
      return (
        <ModalkuForm
          {...this.props}
          changeField={this.props.changeField}
          businessLocationsState={businessLocationsState}
          businessStartsState={businessStartsState}
          logo={logo}
          preApprovedAmount={preApprovedAmount}
          interestRate={interestRate}
          duration={duration}
          lenderName={lenderName}
          monthlyInstallment={monthlyInstallment}
          isMarried={isMarried}
          bankName={bankName}
          sendingRequest={sendingRequest}
          onClickChange={this._onClickChange}
        />
      );
    }
    return '';
  }

  _onClickChange = () => {
    const { capitalForm } = this.props;
    const selectedLoan = {
      tenure: capitalForm.tenor,
      rate: capitalForm.rate,
      amount: capitalForm.preApproveLoan,
      maxLoan: capitalForm.maxLoan,
      lender: capitalForm.lender_name,
    };
    clevertapCapital.capitalClickChange(selectedLoan);
    this.props.dispatch(changePageApplication(1));
  };
}

function mapStateToProps(state) {
  const {
    capital: { sendingRequest },
    moka: { businessLocationsState, businessStartsState, businessTypeState },
  } = state;
  return {
    capitalForm: getFormValues('mokaCapital')(state),
    sendingRequest,
    businessLocationsState,
    businessStartsState,
    businessTypeState,
  };
}

export default connect(mapStateToProps)(DetailForm);
